module.exports = __webpack_public_path__ + "img/top2.50d230ff.png";